<div class="profile-edit-container pt-3" [ngClass]="rootClassName">
  <div class="profile-edit-content">
    <div class="profile-edit-header headingboldlarge">{{title}}</div>
    <div class="frame24pxspacer"></div>
    <hr class="divider"/>
    <div class="frame8pxspacer"></div>
</div>
  <ng-container [ngTemplateOutlet]="form === resetForm ? _resetForm : _editForm"></ng-container>
</div>

<ng-template #_editForm>
  <div class="profile-edit-content">
    <form
      role="form"
      class="form-group"
      [formGroup]="editForm"
    >
      <ng-container [ngTemplateOutlet]="_formGroupProfile" [ngTemplateOutletContext]="{formGroup:editForm}"></ng-container>
      <div class="row">
        <div class="col">
          <ng-container [ngTemplateOutlet]="_formGroupFirstName" [ngTemplateOutletContext]="{formGroup:editForm}"></ng-container>
        </div>
        <div class="col">
          <ng-container [ngTemplateOutlet]="_formGroupLastName" [ngTemplateOutletContext]="{formGroup:editForm}"></ng-container>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="_formGroupEmail" [ngTemplateOutletContext]="{formGroup:editForm}"></ng-container>
      @if (email?.dirty) {
        <ng-container [ngTemplateOutlet]="_formGroupPassword" [ngTemplateOutletContext]="{formGroup:editForm}"></ng-container>
      }
    </form>
    <div class="container p-0">
      <button type="button" class="mt-3 mb-3 px-0 profile-edit-reset linkmediummedium" [ngClass]="{ disabled: isSubmitted }" (click)="onToggle(resetForm)">Change Password</button>
      <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form: editForm, label: {submitting: 'Updating', submit: 'Update'}}"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #_resetForm>
  <div class="profile-edit-content">
    <form
      role="form"
      class="form-group"
      [formGroup]="resetForm"
    >
      <ng-container [ngTemplateOutlet]="_formGroupPassword" [ngTemplateOutletContext]="{formGroup:resetForm}"></ng-container>
      <ng-container [ngTemplateOutlet]="_formGroupNewPassword" [ngTemplateOutletContext]="{formGroup:resetForm}"></ng-container>
      <ng-container [ngTemplateOutlet]="_formGroupConfirmPassword" [ngTemplateOutletContext]="{formGroup:resetForm}"></ng-container>
    </form>
    <div class="container p-0 profile-edit-button-container">
      <ng-container [ngTemplateOutlet]="_cancelButton" [ngTemplateOutletContext]="{form: resetForm, label: {submitting: 'Cancel', submit: 'Cancel'}}"></ng-container>
      <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form: resetForm, label: {submitting: 'Updating', submit: 'Update'}}"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #_initialTemplate>
  <div class="profile-edit-avatar">
    <pop-ui-avatar></pop-ui-avatar>
  </div>
</ng-template>

<ng-template #_avatarTemplate>
  <div class="profile-edit-avatar">
    <img loading="lazy" [attr.src]="avatar_src" [attr.alt]="avatar_alt" class="profile-edit-avatar-image"/>
    <div class="profile-edit-overlay" (click)="onEdit()">
      <img loading="lazy" [attr.src]="avatar_src" [attr.alt]="avatar_alt" class="profile-edit-overlay-image"/>
      <span class="profile-edit-overlay-text labelmediumxsmall">
        <span>Edit</span>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #_formGroupInput
  let-formGroup="formGroup"
  let-formControlName="formControlName"
  let-type="type"
  let-placeholder="placeholder"
  let-description="description"
  let-spellcheck="spellcheck"
  let-autocomplete="autocomplete"
  let-autocapitalize="autocapitalize"
  let-class="class"
  let-requiredFeedback="requiredFeedback"
  let-invalidFeedback="invalidFeedback"
  let-label="label"
>
  <div class="form-floating mb-3" [formGroup]="formGroup" [ngClass]="class">
    <input
      id="{{formControlName}}"
      [type]="type"
      [formControlName]="formControlName"
      [spellcheck]="spellcheck"
      [autocapitalize]="autocapitalize"
      [autocomplete]="autocomplete"
      class="form-control labelregularmedium"
      [ngClass]="{'is-invalid': isInvalid(formGroup, formControlName) }"
      placeholder="{{placeholder}}"
      (keyup.enter)="onSubmit(formGroup)"
    />
    <label for="{{formControlName}}" class="labelregularxsmall">{{label}}</label>
    @if (isInvalid(formGroup, formControlName)) {
      <div class="invalid-feedback">
        @if (isRequired(formGroup, formControlName)) { <div>{{requiredFeedback}}</div> }
      </div>
    }
  </div>
</ng-template>

<ng-template #_formGroupFirstName let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'firstName',
    type:'text',
    spellcheck:'off',
    autocorrect:'off',
    autocomplete:'off',
    autocapitalize:'none',
    placeholder:'Enter First Name',
    description:'a valid email address',
    requiredFeedback:'Please provide a first name.',
    invalidFeedback:'Please provide a first name.',
    label:'First Name',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupLastName let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'lastName',
    type:'text',
    spellcheck:'off',
    autocorrect:'off',
    autocomplete:'off',
    autocapitalize:'none',
    placeholder: 'Enter Last Name',
    description:'a last name',
    requiredFeedback:'Please provide a last name.',
    invalidFeedback:'Please provide a last name.',
    label:'Last Name',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupProfile let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'profile',
    type:'text',
    spellcheck:'off',
    autocorrect:'off',
    autocomplete:'off',
    autocapitalize:'none',
    placeholder:'Enter Profile name',
    description:'a profile name',
    requiredFeedback:'Please provide a profile name.',
    invalidFeedback:'Please provide a profile name.',
    label:'Profile Name',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupEmail let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'email',
    type:'email',
    spellcheck:'off',
    autocorrect:'off',
    autocomplete:'off',
    autocapitalize:'none',
    placeholder:'Enter Email',
    requiredFeedback:'Please provide an email address.',
    invalidFeedback:'Must be a valid email address.',
    label:'Email Address',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupPassword let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'currentPassword',
    type: 'password',
    spellcheck: 'off',
    autocorrect: 'off',
    autocomplete: 'off',
    autocapitalize: 'none',
    placeholder: 'Enter Password',
    requiredFeedback:'Please provide a password.',
    invalidFeedback: 'Must be at least 6 characters.',
    label:'Current Password',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupNewPassword let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'newPassword',
    type: 'password',
    spellcheck: 'off',
    autocorrect: 'off',
    autocomplete: 'off',
    autocapitalize: 'none',
    placeholder: 'Enter Password',
    requiredFeedback:'Please provide a password.',
    invalidFeedback: 'Must be at least 6 characters.',
    label:'New Password',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupConfirmPassword let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'confirmPassword',
    type: 'password',
    spellcheck: 'off',
    autocorrect: 'off',
    autocomplete: 'off',
    autocapitalize: 'none',
    placeholder: 'Enter Password',
    requiredFeedback:'Please provide a password.',
    invalidFeedback: 'Must be at least 6 characters.',
    label:'Confirm Password',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupReset let-formGroup="formGroup">
  <div class="mb-3" [formGroup]="formGroup">
    <div
      class="label-black-op"
      (mouseover)="hover = true"
      (mouseleave)="hover = false"
      [ngStyle]="{ color: hover ? 'black' : 'lightgrey' }"
      (click)="onReset()"
    >
      Forgot Password?
    </div>
  </div>
</ng-template>

<ng-template #_cancelButton
  let-form="form"
  let-label="label"
>
  <button
    type="reset"
    class="btn mt-3 mb-3 profile-edit-cancel text-nowrap labelmediumsmall"
    (click)="onAbort()"
  >
    {{ isSubmitted ? label.submitting : label.submit }}
  </button>
</ng-template>

<ng-template #_submitButton
  let-form="form"
  let-label="label"
>
  <button
    type="submit"
    class="btn mt-3 mb-3 profile-edit-submit text-nowrap labelmediumsmall"
    [disabled]="form.invalid"
    (click)="onSubmit(form)"
  >
    {{ isSubmitted ? label.submitting : label.submit }}
  </button>
</ng-template>

<ng-template #_continueButton
  let-form="form"
  let-label="label"
>
  <button
    type="button"
    class="btn mt-3 mb-3 profile-edit-submit text-nowrap labelmediumsmall"
    [ngClass]="{ disabled: isSubmitted || form.invalid}"
    (click)="onContinue(form)"
    >
    {{ isSubmitted ? label.submitting : label.submit }}
  </button>
</ng-template>

<ng-template #_errorMessage let-form="form">
  <div [ngStyle]="{'color': error(form) ? 'red' : 'initial'}" [ngClass]="{'frame24pxspacer': !error(form) }">{{ errorMessage(form) }}</div>
</ng-template>
